import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { LoginUserActions } from 'redux/actions/LoginUserActions';
import { ModalActions } from "redux/actions/ModalActions";

import { LoginUser } from 'models/LoginUser';
import { ModalData } from 'models/ModalData';
import { StoreModel } from 'models/StoreModel';
import { LoginData } from 'redux/actions/LoginUserActions';

import { ReactForm } from 'app/components/common/Form';
import { NavLink } from 'react-router-dom';
import Translator from './Translator';
import { LegalLinks } from 'app/pages/misc/Legal';

interface IProps {
    modalData: ModalData,
    loginUser: LoginUser,
    store: StoreModel,
    closeModal: typeof ModalActions.closeModal,
    loginUserAction: typeof LoginUserActions.loginUser,
    registerUser: typeof LoginUserActions.moveToRegister,
}

class Modal extends React.Component<IProps> {

    loggedIn() {
        return this.props.loginUser && !!this.props.loginUser.token;
    }

    render() {
        let loginObj: LoginData = {
            userName: '',
            password: ''
        }
        return (
            <div className={'c-modal__wrapper' + (this.loggedIn() ? '' : ' c-modal__wrapper--login')} onClick={() => this.props.closeModal}>
                <div className={'c-modal__dialog' + (this.loggedIn() ? '' : ' c-modal__dialog--login')} onClick={() => { }}>
                    {!this.loggedIn() && <p className='c-modal__brand'>MOPS<i>.</i></p>}
                    <div className='c-modal__header'>
                        {/* the login can't be dismissed, so it gets a title instead of a close button */}
                        {this.loggedIn() ?
                            <a className='c-modal__close' onClick={() => this.props.closeModal()}>
                                <FontAwesomeIcon icon={faTimes}></FontAwesomeIcon>
                            </a> :
                            <h2><Translator text="Log in to MOPS" /></h2>
                        }
                        {this.loggedIn() && this.props.modalData && this.props.modalData.header &&
                            <h2><Translator text={this.props.modalData.header} /></h2>
                        }
                    </div>
                    <div className='c-modal__main'>
                        <ReactForm
                            loginUser={this.props.loginUser}
                            formObject={this.loggedIn() ? this.props.modalData.formObject : loginObj}
                            store={this.props.store}
                            callback={this.loggedIn() ? this.props.modalData.callBack! : this.props.loginUserAction}
                            nonSelectables={this.loggedIn() ? this.props.modalData.nonSelectables : undefined}
                            hidden={this.loggedIn() ? this.props.modalData.hidden : undefined}
                            selectConfigs={this.loggedIn() ? this.props.modalData.selectConfigs : undefined}
                            optionals={this.loggedIn() ? this.props.modalData.optionals : undefined}
                            template={this.loggedIn() ? this.props.modalData.template : undefined}
                        />
                    </div>
                    <div className='c-modal__footer'>
                        {!this.loggedIn() &&
                            <>
                                <Translator text="Forgot your password?" />
                                <NavLink className="c-navigation__link c-navigation__link--in-text" to={"/Account/resetPassword"}>
                                    <Translator text="Reset password" />
                                </NavLink>
                                <br />
                                {/* sign-up lives on the landing page */}
                                <Translator text="New to MOPS?" />
                                <NavLink className="c-navigation__link c-navigation__link--in-text" to={"/welcome"}>
                                    <Translator text="See what it does" />
                                </NavLink>
                            </>
                        }
                    </div>
                    {!this.loggedIn() &&
                        <nav className='c-modal__legal' aria-label='Legal'>
                            <LegalLinks className="c-navigation__link" />
                        </nav>
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: StoreModel) {
    return {
        modalData: state.modalData,
        loginUser: state.loginUser,
        store: state
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        closeModal: bindActionCreators(ModalActions.closeModal, dispatch),
        loginUserAction: bindActionCreators(LoginUserActions.loginUser, dispatch),
        registerUser: bindActionCreators(LoginUserActions.moveToRegister, dispatch)
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Modal);